module.exports = __webpack_public_path__ + "img/portal-icon.deb3c842.svg";